import { render, staticRenderFns } from "./TransactionHistoryItem.vue?vue&type=template&id=61cb240e&scoped=true&"
import script from "./TransactionHistoryItem.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryItem.vue?vue&type=style&index=0&id=61cb240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb240e",
  null
  
)

export default component.exports